import React, { useState, useEffect, useContext } from "react";
import { StoreContext } from "../../store/StoreProvider";

const useModuleLimit = () => {
  const [state] = useContext(StoreContext);
  const { user, common } = state;
  const { limitSetting } = common;
  const { authority } = user;

  const handleLimit = (moduleLimitId) => {
    if (!(moduleLimitId && limitSetting && moduleLimitId in limitSetting))
      return 1;
    const singleMs = limitSetting[moduleLimitId];
    if (!(authority && authority in singleMs)) {
      return singleMs.free;
    }
    return singleMs[authority];
  };

  return { handleLimit };
};

export default useModuleLimit;
